import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { StateService } from '@uirouter/core';
import { Subscription } from 'rxjs';
import { CimaCore, Util, XmStore, XmStoreUtil } from 'core/services';
import { User } from 'store/user/models';
import { Cms5GPlanOverview } from 'store/cms/models';
import { AccountSummary, LineSummary } from 'store/account-summary/models';
import { XmChooseDataOptions } from './choose-data-options/choose-data-options';

@Component({
    selector: 'xm-5g-plan-overview',
    styleUrls: ['./base.scss'],
    templateUrl: './base.html',
    standalone: false
})
export class Xm5GPlanOverview implements OnInit, OnDestroy {
    @ViewChild('XmChooseDataOptions') public chooseDataOptions: XmChooseDataOptions;
    public pageData: Cms5GPlanOverview;
    public unlimited: CmsPlanOverviewUnlimited;
    public btgComparePlanFeatures: CmsPlansFeaturesComparision[];
    public unlimitedComparePlanFeatures: CmsPlansFeaturesComparision[];
    public isBusinessUser: boolean;
    public cbOverview: FiveGPlanOverview;
    public resiOverview: FiveGPlanOverview;
    public planEightOverview: FiveGPlanOverview;
    public planData: FiveGPlanOverview;
    public enablePlanSixCbmSegment3: boolean = false;
    public lines: LineSummary[];

    private cimaCore: CimaCore;
    private xmStore: XmStore;
    private state: StateService;
    private subscriptions: Subscription[] = [];

    constructor(cimaCore: CimaCore, state: StateService, xmStore: XmStore) {
        Object.assign(this, { cimaCore, state, xmStore });
    }

    public ngOnInit(): void {
        this.isBusinessUser = this.cimaCore.isBusinessUser;

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<AccountSummary>(AccountSummary), (accountSummary: AccountSummary) => {
            this.lines = accountSummary.getLinesWithPlans;
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<Cms5GPlanOverview>(Cms5GPlanOverview), (result: Cms5GPlanOverview) => {
            this.pageData = result;
            this.cbOverview = this.pageData.cbPlanSixOverview;
            this.resiOverview = this.pageData.resiPlanSixOverview;
            if (!this.isBusinessUser) {
                this.planData = this.pageData.resiPlanEightOverview;
            } else {
                this.planData = this.pageData.cbmPlanSevenOverview;
            }
            
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<User>(User), (user: User) => {
            this.enablePlanSixCbmSegment3 = this.isBusinessUser && user.account.isSegmentThree;
            if (this.isBusinessUser) {
                if (user.account.isSegmentFour){
                    this.btgComparePlanFeatures = this.pageData.cbPlanSixOverview.byTheGig.compare.featuresForLevel4;
                    this.unlimitedComparePlanFeatures = this.pageData.cbPlanSixOverview.unlimited.compare.featuresForLevel4;
                } else { // user.account.isSegmentThree
                    this.btgComparePlanFeatures = this.pageData.cbPlanSixOverview.byTheGig.compare.featuresForLevel3;
                    this.unlimitedComparePlanFeatures = this.pageData.cbPlanSixOverview.unlimited.compare.featuresForLevel3;
                }
                
            } else {
                if (user.account.isSegmentTwo) {
                    this.btgComparePlanFeatures = this.pageData.resiPlanSixOverview.byTheGig.compare.featuresForLevel2;
                    this.unlimitedComparePlanFeatures = this.pageData.resiPlanSixOverview.unlimited.compare.featuresForLevel2;
                } else if (user.account.isSegmentThree) {
                    this.btgComparePlanFeatures = this.pageData.resiPlanSixOverview.byTheGig.compare.featuresForLevel3;
                    this.unlimitedComparePlanFeatures = this.pageData.resiPlanSixOverview.unlimited.compare.featuresForLevel3;
                } else if (user.account.isSegmentFour) {
                    this.btgComparePlanFeatures = this.pageData.resiPlanSixOverview.byTheGig.compare.featuresForLevel4;
                    this.unlimitedComparePlanFeatures = this.pageData.resiPlanSixOverview.unlimited.compare.featuresForLevel4;
                }
            }
        }));
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }

    public checkDataOptionsBeforeSubmit(): void {
        this.chooseDataOptions.validate();
    }

    public startUpgrade(): void {
        this.state.go('account.settings.level-move.eligibility');
    }
}
